import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "./Components/baseUrl";
import axios from "axios";
import { Link } from "react-router-dom";
import packageJson from "./../package.json";
const Login = () => {
    const [shopId, setShopId] = useState("");
    useEffect(() => {
        window.location.href.split("?")[1] &&
            localStorage.setItem("shop_id", window.location.href.split("?")[1]);
        window.location.href.split("?")[1] &&
            setShopId(window.location.href.split("?")[1]);
    }, []);
    useEffect(() => {
        document.title = "پایا | ورود";
        let version = localStorage.getItem("version");
        if (version != packageJson.version) {
            if ("caches" in window) {
                caches.keys().then((names) => {
                    // Delete all the cache files
                    names.forEach((name) => {
                        caches.delete(name);
                    });
                });

                // Makes sure the page reloads. Changes are only visible after you refresh.

                window.location.href.split("?")[1]
                    ? window.location.href =
                          window.location.href 
                    : window.location.reload(true);
            }

            localStorage.clear();
            localStorage.setItem("version", packageJson.version);
        }
    }, []);
    const [phone, setPhone] = useState("");
    const navigate = useNavigate();
    const loginHandler = (e) => {
        e.preventDefault();
        let data = new FormData();
        data.append("mobile", phone);
        let config = {
            method: "POST",
            url: `${baseUrl}/getVerificationCode`,
            data: data,
        };
        axios(config)
            .then((response) => {
                console.log(response);
                if (response.request.status !== 422) {
                    localStorage.setItem("phone", phone);
                    document.getElementById("to_verify").click();
                }
            })
            .catch(function (err) {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    function refreshPage() {
        setTimeout(() => {
            window.location.reload(false);
        }, 100);
    }
    const [acceptRules, setAcceptRules] = useState(false);
    return (
        <div className="container">
            <Link
                to={{ pathname: "/verify" }}
                id="to_verify"
                onClick={refreshPage}
            ></Link>
            <form className="login-main">
                <img src="./assets/images/logo.svg" alt="" />
                <input
                    type="number"
                    name="phone-number"
                    placeholder="شماره موبایل"
                    onChange={(e) => setPhone(e.target.value)}
                />
                <label className="rules" htmlFor="">
                    <input
                        type="checkbox"
                        onChange={() => setAcceptRules(!acceptRules)}
                    />
                    <span>
                        <a
                            target={"_blank"}
                            href="https://www.payacom.com/privacy-policy/"
                            rel="noreferrer"
                        >
                            قوانین و مقررات{" "}
                        </a>
                        را مطالعه کردم
                    </span>
                </label>
                <button
                    onClick={loginHandler}
                    className="login-btn"
                    type="submit"
                    id="login-btn"
                    disabled={!acceptRules || phone.length == 0}
                >
                    ارسال
                    <svg
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
                            stroke="white"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </button>
                {/* <a onClick={() => navigate("/login_user")} className="login-btn by-username">
                    ورود با نام کاربری
                    <svg
                        width="9"
                        height="15"
                        viewBox="0 0 9 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7 2L1.80417 6.76285C1.3718 7.15918 1.3718 7.84082 1.80417 8.23715L7 13"
                            stroke="white"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </a> */}
            </form>
        </div>
    );
};

export default Login;
